import { Component, JSXElementConstructor, ReactElement, ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// this needs to stay here in order to supress typescript import types
let useComponentToMakeApiExtractorHappy: Component;

export const reactNodeIsOfType = (reactNode: ReactNode, requiredType: unknown): boolean => {
   return isReactNodeOfType(reactNode, requiredType);
};

export const isReactNodeOfType = (reactNode: ReactNode, requiredType: unknown): boolean => {
   return (
      !!reactNode &&
      typeof reactNode === 'object' &&
      !!(reactNode as ReactElement).type &&
      ((reactNode as ReactElement).type === requiredType)
   );
};

export const isReactText = (reactNode: ReactNode): boolean => {
   return typeof reactNode === 'string' || typeof reactNode === 'number';
};

export const childrenAsArray = (children: ReactNode | undefined): Array<ReactNode> => {
   if (typeof children === 'string' || typeof children === 'number') {
      return [children];
   }

   if (children instanceof Array) {
      return children as Array<ReactNode>;
   }

   return [];
};

export declare type ReactElementType = string | JSXElementConstructor<unknown>;

export const childrenOfType = <P = unknown, T extends ReactElementType = JSXElementConstructor<unknown>>(children: ReactNode | undefined, requiredType: unknown): Array<ReactElement<P, T>> => {
   if (children instanceof Array) {
      return (children as Array<ReactElement<P, T>>).filter(child => {
         return reactNodeIsOfType(child, requiredType);
      });
   }

   if (reactNodeIsOfType(children, requiredType)) {
      return [children as any];
   }

   return [];
};

export const findChildOfType = <P = unknown, T extends ReactElementType = JSXElementConstructor<unknown>>(children: ReactNode | undefined,
                                   requiredType: unknown,
                                   predicate: (value: ReactElement<P>, index: number) => unknown): ReactElement<P, T> | undefined => {
   return childrenOfType<P, T>(children, requiredType).find(predicate);
};
